/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable react/no-array-index-key */

/**
 * Renders the ordered and unordered list elements.
 */

// React Imports
import React from "react";

// JSON Forms Imports
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";

import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import {
  evaluateContextRule,
  extractPath,
  resolveContextValueForArrays,
} from "../utils/commonUtils";

// Tester
export const ListRendererTester: RankedTester = rankWith(4, uiTypeIs("List"));

function ListRenderer({ uischema, visible }: RendererProps) {
  // Context
  const context = useJsonForms();

  // UI Schema Options
  const elements = uischema.options?.elements;
  const style = uischema.options?.style;
  const source = uischema.options?.source;
  const target = source?.value;

  // Whether the list is ordered or unordered
  const ListType = uischema.options?.type === "ordered" ? "ol" : "ul";

  // Temporary list of items to render
  let listItems: any[] = [];

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  // Source of data for this component
  switch (source.type) {
    case "env":
      // Source is from environment variables

      // Get the current environment
      const currentEnvironment = get(
        context,
        "config.environment.currentEnvironment",
        ""
      );

      // Get the list items for the current environment
      listItems = get(
        context,
        `config.environment.${currentEnvironment}.${target}`,
        []
      );

      // Break so we can render the list
      break;
    case "context":
      // Source is from context
      const reduxState = useSelector((state: any) => state?.reduxState);
      // Grab our list items from context.
      listItems = resolveContextValueForArrays(
        reduxState,
        target
      ) as unknown as any[];

      // Break so we can render the list
      break;
    default:
      // Source is from inline data
      return (
        <ListType
          data-testid="olist"
          style={style}
          hidden={!componentVisibility}
        >
          {elements.map((element: any, index: number) => (
            <li>
              <JsonFormsDispatch
                key={index}
                renderers={context?.renderers}
                cells={context?.cells}
                uischema={element}
                schema={{}}
              />
            </li>
          ))}
        </ListType>
      );
  }

  // Return items that are not static.
  return (
    <ListType data-testid="olist" style={style} hidden={!componentVisibility}>
      {listItems && listItems.map((element: any) => <li>{element}</li>)}
    </ListType>
  );
}

export default withJsonFormsLayoutProps(ListRenderer);
